/**
 * Description: 接口文档
 * Author: Wangyan
 * Date: 2019-02-25
 * Time: 16:37
 */
global.gatewayBaseUrl = 'https://wsgaj.chutianyun.gov.cn/gateway/'
// global.gatewayBaseUrl = 'https://wsgaj.chutianyun.gov.cn/gateway-test/'
global.gatewayLocalhostBaseApiUrl = '/gateway_apis'
global.commonBaseUrl = 'https://wsgaj.chutianyun.gov.cn/apis/'
// global.commonBaseUrl = 'https://wsgaj.chutianyun.gov.cn/apis-test/'
global.commonLocalhostBaseApiUrl = '/apis'
global.memberUrl = global.baseUrl
global.taskUrl = global.baseUrl
global.EMSUrl = global.baseUrl
global.reservationUrl = global.baseUrl
global.evaluationUrl = global.baseUrl
global.apphubUrl = global.baseUrl
global.consultsUrl = global.baseUrl

global.storageUrl = global.commonLocalhostBaseApiUrl
global.matterUrl = global.baseUrl

// global.imageUrl = 'http://www.smallwhite.work/fs'
global.imageUrl = 'https://wsgaj.chutianyun.gov.cn/fs'
// 图片上传格式
global.filetype = 'image/*';
global.cityCode = 420000 // 湖北省区域编号
global.firstDeptGuid = '420000000000' // 第一级部门的guid
global.firstLevel = 25 // 第一级部门接口筛选层级字符串长度
global.secondLevel = 38 // 第二级部门接口筛选层级字符串长度
global.thirdLevel = 51 // 第二级部门接口筛选层级字符串长度

/**
 * 实人认证
 * @type {string}
 */
global.realAuthenticationUrl = 'https://wsgaj.chutianyun.gov.cn/auth/#'
global.weixinbaseUrl = 'https://wsgaj.chutianyun.gov.cn/weixin'
// global.weixinbaseUrl = 'http://localhost:8888'
global.baiduMapImage = '/staticimage' // 百度地图截图

